import React from 'react';
import { NavLink } from 'react-router-dom';
import Nav from "react-bootstrap/Nav";
import whiteLogo from "../../assets/images/white_logo.png";
import menuIcon from "../../assets/images/menuIcon.png";
import { useSelector } from 'react-redux';

function Sidebar({ setSidebarOpen, sideBarOpen, isMobile }) {

    const organizationStatus = useSelector((state) => state?.organization?.organizationData?.organisation?.logo);

    return (
        <div className={`sidebar ${sideBarOpen && isMobile ? 'sidebarOpen' : ''}`} >
            <div className="sidebar_header position-relative">
                <img
                    src={menuIcon}
                    alt=""
                    className='hideBar cursor'
                    onClick={() => setSidebarOpen(!sideBarOpen)}
                />
                {/* <Link to="#"> */}
                <img
                    src={organizationStatus ? process.env.REACT_APP_MEDIA_URL_ORG + organizationStatus : whiteLogo}
                    alt=""
                    className="logo_img mt-4"
                />
                {/* </Link> */}
            </div>

            <div className={`padd_left ${sideBarOpen && isMobile ? "p //   l-4" : ""}`}>
                <Nav
                    className={`flex-column w-100  pl-lg-4 `}
                >
                    <NavLink to="organization" className="nav-NavLink" onClick={() => setSidebarOpen(!sideBarOpen)}>
                        <span className="ml-2">Organization</span>
                    </NavLink>

                    {/* Hidden for now. The route stays registered, so the
                        screen is still reachable at #/quest-type-package. */}
                    {/* <NavLink to="quest-type-package" className="nav-NavLink" onClick={() => setSidebarOpen(!sideBarOpen)}>
                        <span className="ml-2">Quest Types</span>
                    </NavLink> */}

                    <NavLink to="payment-method" className="nav-NavLink" onClick={() => setSidebarOpen(!sideBarOpen)}>
                        <span className="ml-2">Payment Method</span>
                    </NavLink>

                    {/* Hidden — locations are free, so there is nothing to
                        subscribe to. The route stays registered so historical
                        subscription management is still reachable. */}
                    {/* <NavLink to="manage-subscription" className="nav-NavLink" onClick={() => setSidebarOpen(!sideBarOpen)}>
                        <span className="ml-2">Manage Subscription</span>
                    </NavLink> */}

                    <NavLink to="guide" className="nav-NavLink" onClick={() => setSidebarOpen(!sideBarOpen)}>
                        <span className="ml-2">Guide</span>
                    </NavLink>

                    <NavLink to="setting" className="nav-NavLink" onClick={() => setSidebarOpen(!sideBarOpen)}>
                        <span className="ml-2">Settings</span>
                    </NavLink>
                </Nav>
            </div>
            <img src={whiteLogo} alt='' className='white_logo' />
        </div>
    )
}

export default Sidebar